import type {ForestMassRepository} from '@/domain/interfaces/ForestMassRepository';
import type {ForestMassSpeciesRepository} from '@/domain/interfaces/ForestMassSpeciesRepository';

export class GetForestMassByForestMassSpeciesUuid {
  constructor(
    private readonly forestMassRepository: ForestMassRepository,
    private readonly forestMassSpeciesRepository: ForestMassSpeciesRepository,
  ) {}
  async execute(forestMassSpeciesUuid: string) {
    const forestMassSpecies = await this.forestMassSpeciesRepository.get(forestMassSpeciesUuid);
    if (!forestMassSpecies) {
      throw new Error('Forest mass species not found');
    }
    const uuid = forestMassSpecies.forestMassUuid;
    return this.forestMassRepository.getById(uuid);
  }
}
